import React, {Component} from 'react';

class Footer extends Component {
    render() {
        return (
            <footer id="footer" className="app-footer">
                <div className="wrapper b-t bg-light">
                    <span className="pull-right">2.2.1
                        <a ui-scroll="app" className="m-l-sm text-muted">
                            <i className="fa fa-long-arrow-up"></i>
                        </a>
                    </span>
                    &copy; 2025 Copyright - Todos os direitos reservados.
                </div>
            </footer>
        )
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js